import { FeatureConfiguration } from '@features/tableEngine/types';
import { Flex } from '@radix-ui/themes';
import { Table } from '@tanstack/react-table';
import { UseSelectionResult } from '../hooks';
import { TableBulkActions } from './TableBulkActions';
import { TableSelectionControl } from './TableSelectionControl';

import styles from './SelectionRow.module.css';
import { Action } from '@common/types/actions';

interface SelectionRowProps<TData extends { id: string }> {
    table: Table<TData>;
    selection: FeatureConfiguration<TData>['selection'];
    selectionState: UseSelectionResult<TData>;
    actions: Action<TData>[];
}

export const SelectionRow = <TData extends { id: string }>({
    table,
    selectionState,
    selection,
    actions,
}: SelectionRowProps<TData>) => {
    return (
        <Flex align={'center'} gap={'3'}>
            {selection.enabled && (
                <TableSelectionControl
                    table={table}
                    selectionState={selectionState}
                    displayKey={selection.displayKey}
                />
            )}

            <Flex
                align='center'
                gap='3'
                flexShrink={'0'}
                className={styles.animatedContainer}
            >
                {/* {selection.summaryKey && (
                    <SelectionSummary
                        items={Object.values(selectionState.selectedItems)}
                        summaryKey={selection.summaryKey}
                    />
                )} */}

                <TableBulkActions
                    selectionState={selectionState}
                    actions={actions}
                />
            </Flex>
        </Flex>
    );
};
